export default {
  location: 'Company Registration Address',
  country: 'Country',
  state: 'Province/County',
  city: 'City/Town',
  detailAddress: 'Details like road, buildings and floor.',
  registerSuccess: 'Register successfully',
  registerError: 'Account already exists or phone number has been already registered',
  // 企业商户
  companyName: 'Company Name   ',
  companyNamePlaceholder: 'Enter the company name on the business registration or certificate of incorporation',
  companyRegistrationNo: 'Company Registration No.',
  companyNoPlaceholder: 'Enter the No. on the business registration or certificate of incorporation',
  registerCode: 'Business PIN / VAT No.',
  taxIdentificationNumber: 'Tax Identification Number/ (Business PIN)',
  taxIdentificationPlaceholder: 'The number as listed on tax-related registration document of your business',
  companyUpload: 'Photo of  PIN KRA Certificate and Business Registration Certificate',
  companyUploadTin: 'Photo of TIN Certificate and Business Registration Certificate',
  ruleMsgCompanyName: 'Please check the company name',
  ruleMsgRegisterCode: 'Please check the license no',
  ruleMsgCompanyImage: 'Please upload photos',
  ruleMsgCompanyTooMore: 'No more than 3 photos',
  companyRegistrationUpload: 'Company registration certificate',
  taxIdentificationNumberUpload: ' Tax Identification Number/ PIN Certificate',
  taxIdentificationNumberUploadTin: 'TIN Certificate',
  supportImag: 'Support format: jpg, jpeg, png, pdf',
  // 个人商户
  nameCr: 'Name(CR 12)',
  nameCf: 'Name(CF 20)',
  name: 'Name',
  IDCr: 'ID No.(CR 12)',
  IDCf: 'ID No.(CF 20)',
  ID: 'ID No.',
  nationalID: 'National ID',
  passport: 'Passport',
  idNumber: 'ID Number',
  idNumberPlaceholder: 'Enter legal ID number',
  email: 'Email',
  emailCr: 'Email (CR 12)',
  emailCf: 'Email (CF 20)',
  emailCrPlaceholder: 'Enter email address for qualification-related notification.',
  contactAddress: 'Contact Address',
  businessAddress: 'Business Address',
  personalUpload: ' Front and back of the ID card  ',
  ruleMsgName: 'Please input name    ',
  ruleMsgID: 'Please input the ID No.    ',
  ruleMsgImage: 'Please upload photos of the front and back of the ID card ',
  ruleMsgOne: 'Please upload 2 photos    ',
  ruleMsgTooMore: 'No more than 3 photos',
  ruleMsgState: 'Please select province',
  ruleMsgCity: 'Please select city',
  ruleMsgAddress: 'Please enter full address',
  frontSide: 'Front Side',
  backSide: 'Back Side',

  // 法人信息、结算信息
  basicInfoTitle: 'Basic Information',
  corportateInfoTitle: 'Business Owner or Legal Representative Information',
  settlementInfoTitle: 'Settlement Information',
  phoneNo: 'Phone No.',
  idPhoneFront: 'ID Photo Front',
  idPhoneBack: 'ID Photo Back',
  frontOfPassport: 'Front of Passport (CR 12)',
  frontOfPassportCf: 'Front of Passport (CF 20)',
  settlementMethod: 'Settlement Method',
  settlementCycle: 'Settlement Cycle',
  settlementCurrency: 'Settlement Currency',
  expectedSettlementCurrency: 'Expected Settlement Currency',
  bankName: 'Bank Name',
  bankNamePlaceholder: 'Please enter the full name of the bank',
  bankBranchName: 'Bank Branch Name',
  bankBranchNamePlaceholder: 'Please enter the full branch name of the bank.',
  sWIFTCode: 'SWIFT Code',
  bankCode: 'Bank Code + Branch Code',
  bankLocation: 'Bank Location',
  accountName: 'Account Name',
  cr12: 'CR12',
  cf20: 'CF20',
  accountNamePlaceholder: 'Please enter the business or CR12 associated bank account.',
  accountNamePlaceholderCf: 'Please enter the business or CF20 associated bank account.',
  accountNameYourPlaceholder: 'Please enter the bank account under your name',
  accountNo: 'Account No.',
  accountNoPlaceholder: 'Please enter only the account numbers (0-9)',
  bankCard: 'Bank Card',
  monthlySettlement: 'Monthly Settlement',
  weeklySettlement: 'Weekly Settlement',
  ruleInput: 'Please input ',
  ruleSelect: 'Please select ',
  ruleUpload: 'Please upload ',
  messageInfoA: 'Please ensure the account is consistent with the principal and is working properly, any changes on account information need to be reviewed.',
  messageInfoB: 'Please ensure that the subject of settlement information is consistent with the subject of the business information above.',
  protocolContent: 'I promise the information filled in above is true and effective, otherwise I am willing to bear all legal liabilities and risk losses.',
  merchantRegistration: 'I have read and accepted',
  KilimallEContract: 'Kilimall Seller E-Contract',
  and: '&',
  LipaPayConditions: 'LipaPay Terms and Conditions.',
  MPESRegisteredName: 'M-PESA Registered Name',
  MPESRegisteredPhone: 'M-PESA Registered Phone No.',
  bankInfoDocument: 'Bank Information Document',
  officialBankAccount: 'Official bank document that proves the ownership of the account. ',
  acceptableDocuments: 'Acceptable documents : Bank Card, Bank Account Certificate, RIB or Account Statement.',
  diffIdTip: 'The number you entered has been used by another seller. Please re-enter.',
  confirmDeletedPhone: 'Do you want to delete this photo?',
  resubmitForReview: 'Resubmit for Review',
  save: 'Save',
  mainQualification: 'Main Qualification',
  successfully: 'successfully',
  storeInformation: 'Store Information',
  view: 'View',
  edit: 'Edit',
  storeInformationEditting: 'Store Information Editting',
  applicationID: 'Application ID',
  approvalStatus: 'Approval Status',
  rejectionReason: 'Rejection Reason',
  nameTitle: 'Name',
  multipleStoresCannotCorrected: 'The original qualifications cover multiple stores and cannot be corrected individually.',
  manage: 'Manage',
  lengthNotMeet: 'The length of your ID card number does not meet the requirements.',
  pleaseBankCodeAndBranchCode: 'Please fill in the bank code and branch code. For example, if the bank code is 30 and the branch code is 555, you should enter 30555.'
}
